import styles from './ErrorPage.module.scss';

export default function ErrorPage() {
  return (
    <div className={styles.errorPage}>
      <h1>Ooops! Algo salió mal</h1>
      <p>
        Por favor, vuelva a intentarlo más tarde. Volver a la{' '}
        <a href="/">página de inicio</a>.
      </p>
    </div>
  );
}
